import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  root: {
    backgroundColor: 'rgba(20, 34, 65, 0.95)',
    zIndex: 1
  }
});
